import { Outlet, Navigate } from "react-router-dom";
import { useGetMobileMetadata } from "../api/systemSettings";

// Guards routes behind a System Configuration switch, so a bookmarked URL
// can't reach a section that is switched off and gone from the navbar.
function SystemSettingRoute({ requires }) {
  const { data: settings, isLoading } = useGetMobileMetadata();

  if (isLoading) {
    return null;
  }

  if (!settings?.[requires]) {
    return <Navigate to="/404" />;
  }

  return <Outlet />;
}

export default SystemSettingRoute;
